export default __webpack_public_path__ + "static/tag-dont-1-dark-e50ef6ae6719a013de52b1c3aa70126c156d29fd14d04b026f00f4084d6c335c.png";